import * as React from "react";

import { noop } from "../../utils/noop";
import type * as m from "../../model/model";

export type CompanyInfoContextValue = {
	companyInfo: m.Settings.Controllers.CompanyInfoForView;
	reloadCompanyInfo: () => void;
	isLoading: boolean;
};

// The context provider is implemented differents for web and mobile since web use redux and mobile use mobx
export const CompanyInfoContext = React.createContext<CompanyInfoContextValue>({
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- SS 2024-11-25 Disabled to allow enabling lint rules wtihout changing existing behaviour.
	companyInfo: {} as any,
	reloadCompanyInfo: noop,
	isLoading: false,
});

// If you change name of "useCompanyInfo" here
// Make sure to update the jest.spyOn(companyInfoContext, "useCompanyInfo") in MobileApp and n folder too
export const useCompanyInfo = () => React.use(CompanyInfoContext);
